class Polling {
	/**
	 * 构造函数
	 * @param {Object} options 配置项
	 * @param {Function} options.requestFn 异步请求函数（必须返回Promise）
	 * @param {Function} options.requestFnParams 异步请求函数参数
	 * @param {number} options.interval 轮询间隔(毫秒)，默认5000
	 * @param {number} options.maxRetry 最大错误重试次数，默认3
	 * @param {Function} options.onSuccess 请求成功回调
	 * @param {Function} options.onError 请求失败回调
	 * @param {Function} options.onComplete 轮询完成/停止回调
	 */

	constructor(options = {}) {
		// 默认配置
		this.config = {
			interval: 5000,
			maxRetry: 3,
			requestFn: null,
			requestFnParams: null,
			onSuccess: null,
			onError: null,
			onComplete: null,
		}

		// 合并配置
		Object.assign(this.config, options)

		// 轮训状态
		this.timer = null // 定时器ID
		this.isPolling = false // 是否正在轮询
		this.isPaused = false // 是否暂停轮询
		this.errorRetryCount = 0 // 错误重试计数
	}

	/**
	 * 开始轮询
	 * @param {boolean} immediate 是否立即执行一次（默认true）
	 */

	start(immediate = true) {
		if (this.isPolling) return

		this.isPolling = true
		this.isPaused = false
		this.errorRetryCount = 0

		// 立即执行一次
		if (immediate) {
			this._executeRequest()
		} else {
			// 延迟执行第一次
			this.timer = setTimeout(() => {
				this._executeRequest()
			}, this.config.interval)
		}
	}

	/**
	 * 暂停轮询
	 */
	pause() {
		if (!this.isPolling || this.isPaused) return

		this.isPaused = true
		if (this.timer) {
			clearTimeout(this.timer)
			this.timer = null
		}
	}

	/**
	 * 恢复轮询
	 */
	resume() {
		if (!this.isPolling || !this.isPaused) return

		this.isPaused = false
		this._executeRequest()
	}

	/**
	 * 停止轮询
	 */

	stop() {
		this.isPolling = false
		this.isPaused = false
		if (this.timer) {
			clearTimeout(this.timer)
			this.timer = null
		}

		this.config.onComplete()
	}

	/**
	 * 执行请求（内部方法）
	 */

	async _executeRequest() {
		// 如果已暂停或停止，不执行
		if (!this.isPolling || this.isPaused) return

		try {
			// 执行用户传入的请求函数
			const result = await this.config.requestFn(this.config.requestFnParams)

			// 重置错误重试次数
			this.errorRetryCount = 0
			// 执行成功回调
			this.config.onSuccess(result)

			// 设置下一次轮询
			this.timer = setTimeout(() => {
				this._executeRequest()
			}, this.config.interval)
		} catch (error) {
			// 执行错误回调
			this.config.onError(error)

			// 错误重试逻辑
			this.errorRetryCount++
			if (this.errorRetryCount <= this.config.maxRetry) {
				// 重试间隔递增（退避策略）
				const retryInterval = this.config.interval * this.errorRetryCount
				this.timer = setTimeout(() => {
					this._executeRequest()
				}, retryInterval)
			} else {
				// 达到最大重试次数，停止轮询
				this.stop()
				console.error('轮询请求失败次数达到上限，已停止轮询')
			}
		}
	}
}

export default Polling



// WEBPACK FOOTER //
// ./src/plugins/polling.js